import * as React from 'react'
import { DateTime } from 'luxon'

const MaintenancePage: React.FunctionComponent = (props) => {
	const [maintenanceTimes, setMaintenanceTimes] = React.useState<DateTime[]>([])
	const [collapsed, setCollapsed] = React.useState(false)

	const customCalendar = (date: DateTime) => {
		if (!date.isValid) {
			return ''
		}

		const now = DateTime.now().startOf('day')
		const inputDate = date.startOf('day')

		if (inputDate.equals(now)) {
			return `Today at ${date.toFormat('HH:mm')}`
		} else if (inputDate.equals(now.plus({ days: 1 }))) {
			return `Tomorrow at ${date.toFormat('HH:mm')}`
		} else if (inputDate.equals(now.minus({ days: 1 }))) {
			return `Yesterday at ${date.toFormat('HH:mm')}`
		} else {
			return `${date.toLocaleString(DateTime.DATE_MED)} at ${date.toFormat('HH:mm')}`
		}
	}

	const refresh = () => {
		let timer: NodeJS.Timeout
		fetch('/api/status', { credentials: 'same-origin' })
			.then((res) => (res.ok ? res.text() : undefined))
			.then((res) => {
				if (res) {
					const times = res.split('/')
					const startTime = DateTime.fromISO(times[0])
					setMaintenanceTimes([startTime, DateTime.fromISO(times[1])])
					if (startTime && startTime.isValid) {
						if (timer) {
							clearTimeout(timer)
						}

						// If maintenance is coming up let's update every minute
						const refreshInterval = 1000 * 60
						timer = global.setTimeout(refresh, refreshInterval)
					}
				} else {
					setMaintenanceTimes([])
				}
			})

		// Refresh every 5 minutes
		timer = global.setTimeout(refresh, 1000 * 60 * 5)
	}

	React.useEffect(refresh, [])

	if (maintenanceTimes[0] && maintenanceTimes[0].isValid) {
		const currentDate = DateTime.now()
		const endTime =
			maintenanceTimes[1] &&
			maintenanceTimes[1].isValid &&
			maintenanceTimes[1] > currentDate &&
			maintenanceTimes[1]

		if (currentDate < maintenanceTimes[0]) {
			const seconds = maintenanceTimes[0].diffNow('seconds').seconds
			const minutes = maintenanceTimes[0].diffNow('minutes').minutes

			return (
				<>
					{props.children}
					<div
						style={{
							position: 'fixed',
							backgroundColor: '#EEE',
							boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
							border: '1px solid #CCC',
							borderRadius: 3,
							padding: 10,
							textAlign: 'center',
							bottom: '2vw',
							left: '2vw',
							minWidth: '50px',
							minHeight: '50px',
							maxWidth: '96vw',
							cursor: minutes > 30 ? 'pointer' : undefined,
						}}
						onClick={() => setCollapsed(!collapsed)}
					>
						{collapsed && minutes > 30 ? (
							<h4>
								<i className={`fas fa-exclamation`} />
							</h4>
						) : (
							<>
								<h4>System is going down for maintenance soon!</h4>
								<p>Maintenance starts {customCalendar(maintenanceTimes[0])}</p>
								{endTime && <p>We expect to be done {customCalendar(endTime)}</p>}
								{minutes <= 30 && seconds > 60 && (
									<p>Please save your work within the next {minutes} minutes</p>
								)}
								{seconds <= 60 && <p>Please save your work IMMEDIATELY</p>}
							</>
						)}
					</div>
				</>
			)
		} else {
			return (
				<div style={{ textAlign: 'center', padding: '40px' }}>
					<img src="/img/readpeak_logo_black.png" />
					<h1>MAINTENANCE BREAK</h1>
					{endTime && <p>We expect to be done {customCalendar(endTime)}</p>}
					<hr />
					<p>
						If you have any questions please contact{' '}
						<a href="mailto:support@readpeak.com">support@readpeak.com</a>
					</p>
				</div>
			)
		}
	}

	return <>{props.children}</>
}

export default MaintenancePage
